module.exports = __webpack_public_path__ + "img/Variable-Flavor-Remix3.63aac5f4.png";